import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { UserController } from "services/user/UserController";
import { Button, Dropdown, Input } from "stories";
import { useFetchState } from "utils/customHooks/useFetchState";
import { useToast } from "utils/customHooks/useToast";
import profileData from "../profileData.js";
import classes from "./ProfileForm.module.scss";

const getDefaultValues = () => ({
  address: "",
  email: "",
  city: "",
  company: "",
  country: "",
  fullname: "",
  license_number: "",
  phone_number: "",
  postal_code: "",
  state_or_province: "",
  title: "",
});

const formComponent = (type = "text") =>
  ({ text: Input, list: Dropdown }[type]);

const ProfileForm = ({ userData, setEditMode }) => {
  const form = useForm({
    defaultValues: getDefaultValues(),
  });
  const [controlledFields, setControlledFields] = useState({});
  const user = UserController();
  const [fetchState, sendRequest] = useFetchState();
  const handleEditProfile = (requestBody) => {
    delete requestBody.email;
    sendRequest(user.updateCurrentUserInfo, requestBody);
  };
  const { showToast } = useToast();
  useEffect(() => {
    if (userData) {
      const data = { ...userData };
      delete data.avatar;
      form.reset(data);
      const fields = controlledFields;
      profileData.forEach((item) => {
        if (item.dependent) {
          fields[item.name] = data[item.name];
        }
      });
      setControlledFields(fields);
    }
  }, [userData]); // eslint-disable-line
  useEffect(() => {
    if (
      fetchState.data !== null &&
      !fetchState.isLoading &&
      !fetchState.error
    ) {
      setEditMode(false);
      showToast("Profile updated successfully.", "success");
    }
  }, [fetchState]); // eslint-disable-line

  return (
    <form onSubmit={form.handleSubmit(handleEditProfile)}>
      <Row>
        {profileData.map((item, index) => {
          const Component = formComponent(item.component);
          let { label, name, type, disabled, dependent, ...props } = item;
          if (typeof props.list === "function")
            props.list = props.list(controlledFields);

          return (
            <Controller
              name={name}
              key={index}
              control={form.control}
              render={({ field }) => {
                return (
                  <Col sm={12} md={6}>
                    <Component
                      label={label}
                      type={type || "text"}
                      disabled={disabled || false}
                      {...props}
                      {...field}
                      onChange={(e) => {
                        if (dependent) {
                          setControlledFields({
                            ...controlledFields,
                            [name]: e.target.value,
                          });
                          dependent.forEach((name) => {
                            form.setValue(name, "");
                          });
                        }
                        field.onChange(e);
                      }}
                    />
                  </Col>
                );
              }}
            />
          );
        })}
      </Row>
      <div className={classes["button-wrapper"]}>
        <Button label={"Update Info"} loading={fetchState.isLoading} />
      </div>
    </form>
  );
};

export default ProfileForm;
